import { readonly } from 'vue';
import { state } from '@/store/breadcrumbs/state';
import { methods } from '@/store/breadcrumbs/methods';
import { getters } from '@/store/breadcrumbs/getters';

export const breadcrumbs = readonly({
  state,
  methods: methods(state),
  getters: getters(state),
});
